import * as http from '@/api/config';

/* 搜索书籍 */
export function searchBook(data) {
    const url = 'reader/book/search';
    return http.$get(url, data);
}
/* 搜索书籍章节 */
export function getBookChapter(data) {
    const url = 'reader/book/chapter';
    return http.$get(url, data);
}
/* 搜索书籍章节 */
export function getBookContent(data) {
    const url = 'reader/book/content';
    return http.$get(url, data);
}
/* 收藏书籍 */
export function collectBook(data) {
    const url = 'user/home/v1/user/collect';
    return http.$post(url, {
        ...data,
        type: 0,
    });
}

/* 刷新章节 */
export function refreshBookChapter(data) {
    const url = 'reader/book/chapter/refresh';
    return http.$post(url, data);
}
/* 刷新章节内容 */
export function refreshBookContent(data) {
    const url = 'reader/book/content/refresh';
    return http.$post(url, data);
}


// WEBPACK FOOTER //
// ./src/api/module/reader.js